export type Choice = "import" | "manual"

export const ns = "addLearner"
